import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromResume from '../store/resume/resume.reducer';
import { ResumeRoutingModule } from './resume-routing.module';
import { ResumeEffects } from '../store/resume/resume.effects';
import { GtapMaterialsModule } from '../gtap-materials/gtap-materials.module';
import { ResumesListComponent } from './components/resumes-list/resumes-list.component';
import { CreateResumeComponent } from './components/create-resume/create-resume.component';

@NgModule({
  declarations: [ResumesListComponent, CreateResumeComponent],
  imports: [
    CommonModule,
    GtapMaterialsModule,
    ResumeRoutingModule,
    StoreModule.forFeature(fromResume.resumeFeatureKey, fromResume.reducer),
    EffectsModule.forFeature([ResumeEffects]),
  ],
})
export class ResumeModule {}
